import React, { useContext, useReducer, useState } from 'react';
import { Button, Col, Form, FormControl, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Store } from '../Store';
import useAxios from '../hooks/useAxios';
import { getError } from '../utils';
import LoadingBox from './LoadingBox';

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_REQUEST':
      return { ...state, loadingUpdate: true };
    case 'UPDATE_SUCCESS':
      return { ...state, loadingUpdate: false };
    case 'UPDATE_FAIL':
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};

export default function AskAddressAndApproveOrderModal(props) {
  const axios = useAxios();
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const {
    enterAddressShow,
    setEnterAddressShow,
    customerName,
    approveOrder,
    tableCode,
  } = props;
  const [address, setAddress] = useState({});
  const [addAddress, setAddAddress] = useState(
    !userInfo || !userInfo.addresses || userInfo.addresses.length === 0
      ? true
      : false
  );

  const [{ loadingUpdate }, dispatch] = useReducer(reducer, {
    loadingUpdate: false,
  });

  const addAddressHandler = async (e) => {
    if (!address.city || !address.county || !address.address) {
      toast.error('Lütfen il ilçe ve adres alanlarını eksiksiz doldurunuz!s');
      return;
    }
    dispatch({ type: 'UPDATE_REQUEST' });
    try {
      const { data } = await axios.put(`/api/users/address`, {
        address,
      });
      dispatch({ type: 'UPDATE_SUCCESS' });
      setAddAddress(false);
      ctxDispatch({ type: 'USER_ADD_ADDRESS', payload: data.addresses });
      toast.success('Yeni adresiniz eklendi!');
    } catch (error) {
      dispatch({ type: 'UPDATE_FAIL' });
      toast.error(getError(error));
    }
  };

  const removeAddressHandler = async (id) => {
    dispatch({ type: 'UPDATE_REQUEST' });
    setAddress({});
    try {
      const { data } = await axios.delete(`/api/users/address/${id}`);
      dispatch({ type: 'UPDATE_SUCCESS' });
      ctxDispatch({ type: 'USER_ADD_ADDRESS', payload: data.addresses });
      if (data.addresses.length === 0) {
        setAddAddress(true);
      }
      toast.success('Adres silindi!');
    } catch (error) {
      dispatch({ type: 'UPDATE_FAIL' });
      toast.error(getError(error));
    }
  };

  return (
    <Modal show={enterAddressShow} onHide={() => setEnterAddressShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {!userInfo || !userInfo.addresses || userInfo.addresses.length === 0
            ? 'Lütfen adres bilgilerini giriniz!'
            : 'Lütfen adres seçiniz!'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {addAddress ? (
          <>
            {' '}
            <Form.Group className="mb-3">
              <Form.Label>İl</Form.Label>

              <FormControl
                type="text"
                value={address.city}
                onChange={(e) => {
                  setAddress({ ...address, city: e.target.value });
                }}
                placeholder="İl"
              ></FormControl>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>İlçe</Form.Label>

              <FormControl
                type="text"
                value={address.county}
                onChange={(e) => {
                  setAddress({ ...address, county: e.target.value });
                }}
                placeholder="İlçe"
              ></FormControl>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Adres</Form.Label>

              <FormControl
                as="textarea"
                rows="3"
                value={address.address}
                onChange={(e) => {
                  setAddress({ ...address, address: e.target.value });
                }}
                placeholder="Adres"
              ></FormControl>
            </Form.Group>
          </>
        ) : (
          <Col className="">
            <div>
              <Button
                variant="light"
                className="text-primary border-primary mb-3"
                type="button"
                onClick={() => {
                  setAddAddress(true);
                  setAddress({});
                }}
              >
                <i className="fas fa-plus"></i>
                &nbsp;Yeni Adres
              </Button>
            </div>
          </Col>
        )}
        {!addAddress && userInfo && userInfo.addresses && (
          <>
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th></th>
                  <th>Lütfen bir adres seçiniz!</th>
                </tr>
              </thead>
              <tbody>
                {userInfo.addresses.map((a) => (
                  <tr key={a._id}>
                    <td>
                      <Form.Check
                        inline
                        type="radio"
                        checked={a._id === address._id}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setAddress(a);
                          }
                        }}
                      />
                    </td>
                    <td>
                      <div>
                        {a.address}&nbsp;
                        <span className="text-muted">
                          {a.county}&nbsp;{a.city}
                        </span>
                      </div>
                    </td>
                    <td>
                      <Link
                        to=""
                        className="textdecorationnone"
                        onClick={() => removeAddressHandler(a._id)}
                      >
                        <i className="text-danger fas fa-trash"></i>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {addAddress && (
          <>
            {loadingUpdate && <LoadingBox></LoadingBox>}
            <Button
              variant="light"
              className="text-danger border-danger"
              disabled={loadingUpdate}
              onClick={() => {
                setAddAddress(false);
              }}
            >
              <i className="fas fa-times"></i>&nbsp; İptal
            </Button>

            <Button
              variant="light"
              disabled={loadingUpdate}
              className="text-primary border-primary"
              onClick={() => {
                addAddressHandler();
              }}
            >
              <i className="fas fa-check"></i>&nbsp; Kaydet
            </Button>
          </>
        )}
        {!addAddress && (
          <Button
            variant="primary"
            disabled={!address._id}
            onClick={() => {
              setEnterAddressShow(false);
              approveOrder(tableCode, customerName, address);
            }}
          >
            Siparişi Onayla
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
